module.exports = __webpack_public_path__ + "img/feature3.4129288c.jpg";